var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_396:10415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9817 2.066C8.88271 1.89357 8.73998 1.7503 8.56791 1.65067C8.39584 1.55105 8.20053 1.49858 8.0017 1.49858C7.80287 1.49858 7.60756 1.55105 7.43549 1.65067C7.26343 1.7503 7.12069 1.89357 7.0217 2.066L0.164702 13.733C-0.292298 14.511 0.255702 15.5 1.1447 15.5H14.8577C15.7467 15.5 16.2957 14.51 15.8377 13.733L8.9817 2.066ZM7.9997 5.5C8.5347 5.5 8.9537 5.962 8.8997 6.495L8.5497 10.002C8.53794 10.1398 8.4749 10.2681 8.37306 10.3616C8.27121 10.4552 8.13797 10.5071 7.9997 10.5071C7.86143 10.5071 7.72819 10.4552 7.62635 10.3616C7.5245 10.2681 7.46146 10.1398 7.4497 10.002L7.0997 6.495C7.08713 6.36924 7.10105 6.24223 7.14055 6.12217C7.18005 6.00211 7.24426 5.89165 7.32905 5.79791C7.41383 5.70418 7.51731 5.62924 7.63282 5.57793C7.74833 5.52662 7.87331 5.50007 7.9997 5.5ZM8.0017 11.5C8.26692 11.5 8.52127 11.6054 8.70881 11.7929C8.89634 11.9804 9.0017 12.2348 9.0017 12.5C9.0017 12.7652 8.89634 13.0196 8.70881 13.2071C8.52127 13.3946 8.26692 13.5 8.0017 13.5C7.73649 13.5 7.48213 13.3946 7.2946 13.2071C7.10706 13.0196 7.0017 12.7652 7.0017 12.5C7.0017 12.2348 7.10706 11.9804 7.2946 11.7929C7.48213 11.6054 7.73649 11.5 8.0017 11.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_396:10415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.54c98493a7640fe5165d221cd50083a9.svg";
export { ForwardRef as ReactComponent };